import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../Assets/logo.png";
import { Link } from "react-router-dom";
import { AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { BiNetworkChart, BiGlobe } from "react-icons/bi";

function NavBar() {
  return (
    <Navbar variant="dark" expand="md" fixed="top" className="shadow-sm fontana-navbar navbar-cerulean border-accent">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" aria-label="Home">
          <img src={logo} alt="Fontana logo" className="img-fluid me-2" style={{ height: "2.2em" }} />
          <span className="fw-bold fs-4">FONTANA</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" aria-label="Toggle navigation" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" className="d-flex align-items-center" aria-label="Go to Home">
              <AiOutlineHome className="me-2" aria-hidden="true" /> Home
            </Nav.Link>
            <Nav.Link as={Link} to="/ecosystem" className="d-flex align-items-center" aria-label="Go to Ecosystem">
              <BiNetworkChart className="me-2" aria-hidden="true" /> Ecosystem
            </Nav.Link> 
            <Nav.Link as={Link} to="/lumeria-reality" className="d-flex align-items-center" aria-label="Go to Metaverse">
              <BiGlobe className="me-2" aria-hidden="true" /> Metaverse
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className="d-flex align-items-center" aria-label="Go to About">
              <AiOutlineUser className="me-2" aria-hidden="true" /> About
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
